<p-confirmDialog key="modify" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>
<p-confirmDialog key="modifyerror" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--Main Grid-->
<div class="MainGrid2Col">
	<!--INSERT CUSTOM POPUP FIELDS-->
	<label>Code:</label>
	<input [disabled]="IsLoading() == true" class="form-control" type="text" placeholder="10 Charcter Alert Type Code/Abbreviation" [(ngModel)]="AlertTypeCD" />

	<label>Description:</label>
	<input [disabled]="IsLoading() == true" class="form-control" type="text" placeholder="Alert Type Name/Description" [(ngModel)]="AlertTypeDesc" />

	<label>Severity:</label>
	<select [disabled]="IsLoading() == true" class="form-control" name="Severity" [(ngModel)]="Severity">
		<option *ngFor="let r of lstSeverity" [ngValue]="r.ID">
			{{ r.Desc }}
		</option>
	</select>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="IsLoading() == true" *ngIf="EditMode == false" class="btn btn-primary" (click)="onAdd()">Add</button>
	<button [disabled]="IsLoading() == true" *ngIf="EditMode == true" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button [disabled]="Processing == true" class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
